import { App } from 'antd'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { QR_PANEL_STATUS } from '../constants'
import type { QrPanelState } from '../types'

export const useQrTerminalNotice = (status: QrPanelState['status']) => {
  const { message } = App.useApp()
  const { t } = useTranslation()
  const shownStatusRef = useRef<QrPanelState['status'] | null>(null)

  useEffect(() => {
    if (status === QR_PANEL_STATUS.STARTING) {
      shownStatusRef.current = null
      return
    }

    if (
      (status !== QR_PANEL_STATUS.DENIED &&
        status !== QR_PANEL_STATUS.CANCELED) ||
      shownStatusRef.current === status
    ) {
      return
    }

    shownStatusRef.current = status
    message.error(
      status === QR_PANEL_STATUS.DENIED
        ? t('auth.qrSignIn.deniedToast')
        : t('auth.qrSignIn.canceledToast')
    )
  }, [message, status, t])
}
